// extracted by mini-css-extract-plugin
export var addToCartButton = "_or-b";
export var arrowButtonContainer = "_or-9";
export var arrowButtonIcon = "_or-a";
export var carouselArrowButton = "_or-6";
export var carouselElementContainer = "_or-1";
export var galleryThumbnail = "_or-d";
export var galleryThumbnailImage = "_or-e";
export var left = "_or-7";
export var productDisplayCarouselContainer = "_or-0";
export var productTileContainer = "_or-2";
export var productTileImage = "_or-4";
export var productTileImageContainer = "_or-3";
export var productTileTitle = "_or-5";
export var right = "_or-8";
export var sliderOverflow = "_or-c";